// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleHeading_root__1s_oj","hed1":"ArticleHeading_hed1__2WPWz","hed2":"ArticleHeading_hed2__1mKuy","hed3":"ArticleHeading_hed3__2mjuu","hed4":"ArticleHeading_hed4__UZYrX"};